module.exports = __webpack_public_path__ + "img/banner.e0cc358e.png";